import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Box,
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import { PaginateNavigate } from "components/paginateComponent/PaginateComponent";
import { useService } from "hooks/ServicesHook";
import React from "react";
import { useState } from "react";
import { useQuery } from "react-query";
import { formatDate } from "utils/formaterDate";
import { formaterDocument } from "utils/formaterDocumente";

interface ModalNKPProps {
  isOpen: boolean;
  onClose: () => void;
  typeModal: "S" | "N";
  qtdBKP: number;
}

export function ModalBKP({
  isOpen,
  onClose,
  typeModal,
  qtdBKP,
}: ModalNKPProps) {
  const brandColor = useColorModeValue("brand.500", "white");
  const [paginate, setPaginate] = useState<number>(1);
  const boxBg = useColorModeValue("secondaryGray.300", "navy.900");
  const subTable = useColorModeValue("secondaryGray.300", "navy.700");
  const [exibirDetalhes, setExibirDetalhes] = useState<any>({});

  const { findBKPsByParm } = useService();
  const { data, isLoading, error } = useQuery(
    ["findBKPsByParm", typeModal, paginate],
    () =>
      findBKPsByParm({
        page: paginate,
        realizado: typeModal,
      })
  );

  const toggleDetalhes = (chave: any) => {
    setExibirDetalhes((prevState: any) => ({
      ...prevState,
      [chave]: !prevState[chave],
    }));
  };

  return (
    <Modal
      motionPreset="slideInBottom"
      size="6xl"
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent bg={boxBg}>
        <ModalHeader>
          {typeModal === "S" ? "Backup com sucesso: " : "Backup com erro: "}
          {qtdBKP}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {isLoading ? (
            <Box display="flex" alignItems="center" justifyContent="center">
              <Spinner
                speed="0.65s"
                width="100px"
                height="100px"
                thickness="4px"
              />
            </Box>
          ) : error ? (
            <Box
              color="red.500"
              fontWeight="bold"
              fontSize="xl"
              textAlign="center"
              p={8}
            >
              {String(error)}
            </Box>
          ) : (
            <>
              <TableContainer>
                <Table>
                  <Thead>
                    <Tr>
                      <Th>Empresa</Th>
                      <Th>CNPJ</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {data?.data.map((item: any) => (
                      <React.Fragment key={item.DOCUMENTO}>
                        <Tr
                          color={brandColor}
                          cursor={"pointer"}
                          _hover={{
                            bg: "var(--chakra-filled-background-hover)",
                          }}
                          onClick={() => toggleDetalhes(item.ID)}
                          transition={"0.3s"}
                        >
                          <Td>{item.NOME}</Td>
                          <Td>{formaterDocument(item.DOCUMENTO)}</Td>
                        </Tr>
                        {exibirDetalhes[item.ID] && (
                          <Tr>
                            <Td colSpan={2}>
                              <Table bg={subTable}>
                                <Thead>
                                  <Tr>
                                    <Th>DATA</Th>
                                    <Th>VIA SSH</Th>
                                    <Th>OBS</Th>
                                  </Tr>
                                </Thead>
                                <Tbody>
                                  {item.BKPS.map((bkp: any, index: any) => (
                                    <Tr key={index}>
                                      <Td>{formatDate(bkp.DATA)}</Td>
                                      <Td>{bkp.VIA_SSH ? "SIM" : "NÃO"}</Td>
                                      <Td>{bkp.OBSERVACAO}</Td>
                                    </Tr>
                                  ))}
                                </Tbody>
                              </Table>
                            </Td>
                          </Tr>
                        )}
                      </React.Fragment>
                    ))}
                  </Tbody>
                </Table>
              </TableContainer>
              <PaginateNavigate
                current_page={data?.current_page}
                pages_preview={data?.preview_url}
                pageSelect={setPaginate}
                lastPage={data?.last_page}
              />
            </>
          )}
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="red" onClick={onClose}>
            Fechar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
